/**
 * Value compare for non-collection built-in objects (when
 * possible, identity comparison otherwise).
 *
 * @param  {(-Collection)} a
 * @param  {(-Collection)} b
 * @return {boolean}
 */
export default function valueEquals (a, b, allowSubTypes = true) {
  // get null and other value built-ins out of the way first
  // to avoid problems with 'in' checks and so on
  if (a === null
      || a === undefined
      || a === Infinity
      || a === NaN) {
    return a === b;
  }

  // get primitives out of the way, discarding object
  // wrappers if necessary:
  let primitiveA = a, primitiveB = b;
  if (typeof a === 'object' && Symbol.toPrimitive in a) {
    primitiveA = a[Symbol.toPrimitive]('default');
  }
  if (typeof b === 'object' && Symbol.toPrimitive in b) {
    primitiveB = b[Symbol.toPrimitive]('default');
  }
  if (typeof primitiveA === 'boolean'
      || typeof primitiveA === 'number'
      || typeof primitiveA === 'string'
      || typeof primitiveA === 'symbol'
      || typeof primitiveA === 'function') {
    return primitiveA === primitiveB;
  }

  // for things with actual types, check types first
  if (allowSubTypes) {
    if (!(a instanceof b.constructor
        || b instanceof a.constructor)) {
      return false;
    }
  } else {
    if (a.constructor !== b.constructor) {
      return false;
    }
  }
  // types that can only be identity-compared

  if (a instanceof Function
      || a instanceof Error) {
    return a === b;
  }

  // complex types that could be thought of value-equivalent:

  if (a instanceof Date) {
    return a.valueOf() === b.valueOf();
  }

  if (a instanceof RegExp) {
    // execution context is intentionally ignored because it
    // doesn't really figure into value-equivalence
    return (a.source === b.source
      && a.flags === b.flags);
  }

  if (this.isCollection(a) || this.isCollection(b)) {
    throw new Error('Cannot value-compare collections!');
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/valueEquals.js